const dialogRegistry = {
  onboardingDialog: defineAsyncComponent(
    () =>
      import("~/business-areas/onboarding/components/onboarding-dialog.vue"),
  ),
  postRegistrationLinkDialog: defineAsyncComponent(
    () =>
      import(
        "~/business-areas/registration-link/components/registration-link-post-registration-dialog.vue"
      ),
  ),
  offerComparisonDialog: defineAsyncComponent(
    () =>
      import("~/business-areas/offer/components/offer-comparison-dialog.vue"),
  ),
} satisfies Record<string, ReturnType<typeof defineAsyncComponent>>;

export { dialogRegistry };
